import React from 'react';

import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';
import { nutritionRegistrationService } from '../../../../auth-management/services/registrationService/nutritionRegistrationService';
import { RegistrationFormAccessWidget } from '../../../../auth-management/components/RegistrationFormAccessWidget/RegistrationFormAccessWidget';

const CoachNutritionRegistrationTab = () => {
  const entityId = loggedInUserDataStore.getEntityId();

  return (
    <RegistrationFormAccessWidget
      id={entityId}
      getRegistrationLink={nutritionRegistrationService.getRegistrationLink}
      getRegistrationQrCode={nutritionRegistrationService.getRegistrationQrCode}
      qrCodeDescription="A QR code has already been generated and assigned to your entity"
    />
  );
};

export { CoachNutritionRegistrationTab };
